import React from 'react';

import BillingPageContent from 'components/dashboard/billing-content/BillingPageContent';

const DashboardBillingPage = () => <BillingPageContent />;

export default DashboardBillingPage;
